// components/PayslipHeaderDetails.js

export default function NameAndTitleContent({
  styles,
  fullName,
  date,
  checkCase,
}) {
  const getPayrollTitle = () => {
    if (
      checkCase("isBasicGeneral") ||
      checkCase("isBasicAddendum") ||
      checkCase("isBasicJoSalary") ||
      checkCase("isBasicJoAddendum") ||
      checkCase("isBasicBackpay")
    ) {
      return "BASIC PAYSLIP";
    } else if (checkCase("isApGeneralNewly") || checkCase("isApBackPay")) {
      return "AUGMENTATION PAYSLIP";
    } else {
      return "";
    }
  };

  const title = getPayrollTitle();

  return (
    <>
      <div style={styles.nameSection}>
        <p style={styles.name}>NAME:</p>
        <div style={styles.fullName}>{fullName}</div>
      </div>

      <h5 style={{ ...styles.textCenter, ...styles.title }}>{title}</h5>
      <h5 style={{ ...styles.textCenter, ...styles.title }}>{date}</h5>
    </>
  );
}
